<template>
    <va-edit-layout>
        <AdjustmentEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></AdjustmentEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
